export function flattenHeadings(headings = []) {
    return headings.reduce((acc, curr) => {
        acc.push(curr)
        acc.push(...curr.children)
        return acc
    }, [])
}

/** Only extract h2 and h3 */
export function extractHeadings(rootElement, addIntroduction = false) {
    const results = []
    const headingEls = rootElement.querySelectorAll('h2, h3')
    let currentHeading = null

    if (addIntroduction) {
        const text = 'Introduction'
        results.push({
            text,
            level: 2,
            children: [],
            slug: text.toLowerCase(),
        })
    }

    for (let i = 0; i < headingEls.length; i++) {
        const el = headingEls[i]
        const level = parseInt(el.tagName.substring(1), 10)
        const id = el.id || el.querySelector('div')?.id

        if (!id) {
            continue
        }

        const newHeading = {
            level,
            text: el.innerText,
            slug: id,
            children: [],
        }

        if (currentHeading && newHeading.level > currentHeading.level) {
            newHeading.parent = currentHeading.slug
            currentHeading.children.push(newHeading)
        } else {
            results.push(newHeading)
            currentHeading = newHeading
        }
    }

    return results
}
